import { Content } from "@/components/ui/ContentArea";
import { ProyectosDashboard } from "./ProyectosDashboard";

export function ProyectosPage() {
	return (
		<Content className="p-5">
			<title>Listado de Proyectos</title>
			<ProyectosDashboard />
		</Content>
	);
}
